export default "__VITE_ASSET__C6$E7MwV__"